
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["oeamtc-button__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.103 9.004l-2.286 2.285H7.429c-.632 0-1.143.513-1.143 1.144v8c0 .631.511 1.143 1.143 1.143H24.57c.632 0 1.143-.512 1.143-1.143v-8c0-.631-.511-1.143-1.143-1.143l-1.673-.001 2.239-2.238A3.43 3.43 0 0128 12.433v8a3.429 3.429 0 01-3.429 3.428H7.43A3.429 3.429 0 014 20.433v-8a3.429 3.429 0 013.429-3.429h9.674zm-2.364 4.01l2.42 2.428-.777.778-2.884.46.46-2.884.781-.783zm7.3-7.3l2.424 2.425-6.461 6.46-2.434-2.414 4.656-4.657.589-.588 1.225-1.226zm3.636-1.212c.67.67.67 1.755 0 2.424l-.402.402-2.426-2.422.404-.404c.67-.67 1.755-.67 2.424 0z"}})])
          )
        }
      }
    